export default __webpack_public_path__ + "static/media/480_store03-it-web.6463d1e8.png";